import React, { FC } from 'react';
import styled  from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { globalTheme } from '@cld/component-theme';
import { overrides } from '@cld/button';
import { messages } from '../../../../i18n';
import { Logo } from '../../../common/Logo';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { Links } from './Links';
import { Contact } from './Contact';

const StyledButtonLink = styled(overrides.mediaLibraryWidgetDemoOverrides.ButtonLink)`
  margin-left: calc(${globalTheme.spacing.lg} * 5);
`;

const Root = styled.div`
  padding: calc(${globalTheme.spacing.lg} * 2) calc(${globalTheme.spacing.lg} * 10) calc(${globalTheme.spacing.lg} + ${globalTheme.spacing.xs});
  display: flex;
  margin: auto;
  max-width: calc(${globalTheme.spacing.lg} * 68);

  > * {
    padding: 0 ${globalTheme.spacing.lg};
  }

  ${Logo} {
    height: ${globalTheme.spacing.xl};
  }
`;

const LogoLink = styled.a`
  align-self: flex-start;
`;

const LinksWrapper = styled.div`
  margin-left: calc(${globalTheme.spacing.lg} * 6);
`;

const ContactWrapper = styled.div`
  margin-left: calc(${globalTheme.spacing.lg} * 3);
`;

export const Body: FC = () => {
  const analytics = useAnalytics();

  return (
    <Root>
      <LogoLink
        href="https://cloudinary.com/"
        target="_blank"
        rel="noopener noreferrer"
        data-test="footer-logo-link"
        onClick={() => analytics('navigation', 'footer logo')}
      >
        <Logo blue />
      </LogoLink>
      <LinksWrapper>
        <Links />
      </LinksWrapper>
      <ContactWrapper>
        <Contact />
      </ContactWrapper>
      <StyledButtonLink
        size="sm"
        shape="pill"
        onClick={() => analytics('sign up', 'intent to sign up')}
        data-test="footer-sign-up-button"
        href="https://cloudinary.com/users/register/free"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FormattedMessage {...messages['landing.signUpForFree']} />
      </StyledButtonLink>
    </Root>
  );
};
